import { useState, useEffect } from "react";
import "@/App.css";
import VerificationGate from "./components/VerificationGate";
import LinksPage from "./components/LinksPage";

function App() {
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("foo_verified") === "1") {
      setVerified(true);
    }
  }, []);

  const handleVerified = () => {
    sessionStorage.setItem("foo_verified", "1");
    setVerified(true);
  };

  return (
    <div className="App" data-testid="app-root">
      {verified ? <LinksPage /> : <VerificationGate onVerified={handleVerified} />}
    </div>
  );
}

export default App;
